<template>
  <div>
    <component-new-header
      title="Create Bulk Promotion"
      :isLoading="loading"
      :hasSearch="false"
      :hasReload="false"
      :hasRadio="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/bulkPromotion')"
    />
    <b-card>
      <b-row>
        <b-col md="6">
          <b-row>
            <b-col md="12">
              <h5 class="text-primary">Select Entity</h5>
            </b-col>
            <b-col md="10">
              <eb-select
                disabled
                style="background-color: #fff"
                id="text"
                type="text"
                label="text"
                placeholder="Select Entity"
                :options="entityOptions"
                v-model="entity"
                :selected="selectedEntity"
              >
              </eb-select>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-row>
            <b-col md="12">
              <h5 class="text-primary">Criteria Selection</h5>
            </b-col>
            <b-col md="10">
              <ev-select
                disabled
                style="background-color: #fff"
                id="text"
                type="text"
                label="text"
                placeholder="Select Criteria"
                :options="criteriaOptions"
                v-model="selectedCriteriaOptions"
                :selected="selectedCriteriaOptions"
              >
              </ev-select>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-for="(option, index) in selectedCriteriaOptions" :key="index">
        <b-col md="2">
          <label class="mt-2">{{ option }}</label>
        </b-col>
        <b-col md="3">
          <eb-select
            disabled
            type="text"
            label="text"
            placeholder="Select Option"
            :options="operatorOptions"
            v-model="selectedOperator"
            :selected="selectedOperator[index]"
          >
          </eb-select>
        </b-col>
        <b-col md="5" offset="1">
          <b-form-input
            readonly
            v-if="
              option !== 'Age' && option !== 'Date' && option !== 'Order Amount'
            "
            v-model="inputData[index].value"
          >
          </b-form-input>

          <b-row style="padding: 0px 20px" v-if="option === 'Age'">
            <b-col style="padding: 0px" md="5">
              <p>{{ inputData[index].value.gte }}</p>
            </b-col>
            <b-col style="padding: 0px 20px" md="4">
              <label>Select Age</label>
            </b-col>
            <b-col style="padding: 0px" md="3">
              <p style="float: right">{{ inputData[index].value.lte }}</p>
            </b-col>
            <b-form-input
              disabled
              type="range"
              min="0"
              :max="max"
              v-model="inputData[index].value"
            ></b-form-input>
          </b-row>

          <b-row v-if="option === 'Order Amount'">
            <b-col md="6">
              <b-input
                disabled
                :id="`start-date${index}`"
                type="number"
                placeholder="Lower Amount"
                v-model="inputData[index].value.gte"
              ></b-input>
            </b-col>
            <b-col md="6">
              <b-input
                disabled
                :id="`end-date${index}`"
                type="number"
                placeholder="Higher Amount"
                v-model="inputData[index].value.lte"
              ></b-input>
            </b-col>
          </b-row>

          <b-row v-if="option === 'Date'">
            <b-col>
              <b-row>
                <b-col md="6">
                  <b-input
                    disabled
                    id="start-date"
                    type="date"
                    v-model="inputData[index].value.startDate"
                  ></b-input>
                </b-col>
                <b-col md="6">
                  <b-input
                    disabled
                    id="end-date"
                    type="date"
                    v-model="inputData[index].value.endDate"
                  ></b-input>
                </b-col>
                <!-- <b-col md="4">
                    <b-button
                      disabled
                      block
                      :pressed.sync="myToggle"
                      size="sm"
                      variant="success"
                      class="form-control"
                      >Confirm Date</b-button
                    >
                  </b-col> -->
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- <b-row class="justify-content-md-center my-2">
          <b-button disabled variant="primary" class="w-25"
            >VIEW IMPACTED CUSTOMER</b-button
          >
        </b-row> -->
    </b-card>

    <b-row class="my-2">
      <b-col>
        <b-button variant="success" style="border-radius: 18px"
          >Impacted Customer ({{ getDataCriteriaById.count || 0 }})
          <span class="ml-3 mr-1">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
        </b-button>
      </b-col>
      <b-col>
        <b-button
          @click="downloadDetails"
          variant="outline-primary"
          style="float: right"
        >
          <i class="fa fa-file-text-o mx-2" aria-hidden="true"></i>Download
        </b-button>
      </b-col>
    </b-row>
    <b-card>
      <h4 class="text-primary">Promotional Configuration</h4>
      <b-row>
        <b-col>
          <eb-select
            :disabled="
              getDataCriteriaById.count == '' ||
              getDataCriteriaById.notificatonStatus == 'COMPLETED' ||
              getDataCriteriaById.status == 'PENDING'
            "
            type="text"
            label="text"
            placeholder="Promotion Type"
            :options="typeOfPromo"
            v-model="promoType"
            :selected="promoType"
            @input="templateTypeList"
          ></eb-select>
        </b-col>
        <b-col>
          <eb-select
            :disabled="
              getDataCriteriaById.count == '' ||
              getDataCriteriaById.notificatonStatus == 'COMPLETED' ||
              getDataCriteriaById.status == 'PENDING'
            "
            type="text"
            label="text"
            placeholder="Notification Type"
            :options="typeOfNotificationOption"
            v-model="notificationOption"
            :selected="notificationOption"
            @input="templateTypeList"
          ></eb-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <eb-select
            :disabled="
              getDataCriteriaById.count == '' ||
              getDataCriteriaById.notificatonStatus == 'COMPLETED' ||
              getDataCriteriaById.status == 'PENDING'
            "
            type="text"
            label="text"
            placeholder="Choose Template"
            :options="templateOptionList"
            v-model="templateOption"
            :selected="templateOption"
            @input="previewSelectedTemplate"
          >
          </eb-select>
        </b-col>
        <b-col>
          <b-form-input
            :disabled="
              getDataCriteriaById.count == '' ||
              getDataCriteriaById.notificatonStatus == 'COMPLETED' ||
              getDataCriteriaById.status == 'PENDING'
            "
            type="number"
            placeholder="Promotion Amount"
            v-model="promoAmount"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <div
          disabled
          contentEditable="false"
          placeholder="Preview Template"
          class="mb-3 pr-3 previewTemplate"
          v-html="showPreviewHere"
        ></div>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-input
            :disabled="
              getDataCriteriaById.count == '' ||
              getDataCriteriaById.notificatonStatus == 'COMPLETED' ||
              getDataCriteriaById.status == 'PENDING'
            "
            placeholder="Description"
            v-model="description"
          ></b-form-input>
        </b-col>
        <b-col md="2">
          <b-input
            disabled
            type="text"
            label="label"
            placeholder="Choose Effective Timestamp"
          ></b-input>
        </b-col>
        <b-col md="2">
          <b-input
            :disabled="
              getDataCriteriaById.count == '' ||
              getDataCriteriaById.notificatonStatus == 'COMPLETED' ||
              getDataCriteriaById.status == 'PENDING'
            "
            id="time-stamp"
            type="date"
            v-model="timestampDate"
          ></b-input>
        </b-col>
        <b-col md="2">
          <b-input
            :disabled="
              getDataCriteriaById.count == '' ||
              getDataCriteriaById.notificatonStatus == 'COMPLETED' ||
              getDataCriteriaById.status == 'PENDING'
            "
            id="time-stamp"
            type="time"
            v-model="timestampTime"
          ></b-input>
        </b-col>
      </b-row>
      <b-row class="my-2">
        <b-col
          ><h5 class="impactValueStyle">
            Total Impacted value :
            {{ this.promoAmount * getDataCriteriaById.count || 0 }}
          </h5>
        </b-col>
        <b-col>
          <b-button
            :hidden="
              getDataCriteriaById.count == '' ||
              getDataCriteriaById.notificatonStatus == 'COMPLETED' ||
              getDataCriteriaById.status == 'PENDING'
            "
            @click="createBulkNotification"
            variant="primary"
            style="float: right"
            class="w-25"
            >SUBMIT</b-button
          >
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import evSelect from "@/components/FormElements/Multiselect.vue";
import ebButton from "@/components/FormElements/Button";
import ComponentNewHeader from "@/components/componentNewHeader";

import { mapGetters } from "vuex";
export default {
  components: { ebSelect, evSelect, ebButton, ComponentNewHeader },
  data() {
    return {
      resourceId:"",
      promoAmount: "",
      promoType: "",
      entity: "",
      loading: false,
      previewScreen: "",
      description: "",
      myToggle: false,
      rangeValue: 18,
      max: 100,
      startDate: "",
      endDate: "",
      startEndDate: "",
      criteriaOptions: [],
      operatorOptions: [],
      criteria: [],
      entityOptions: [
        {
          text: "Order",
          value: "ORDER",
        },
        {
          text: "Customer",
          value: "CUSTOMER",
        },
      ],
      typeOfNotificationOption: [
        // {
        //   text: "Email",
        //   value: "EMAIL",
        // },
        {
          text: "Inapp",
          value: "INAPP",
        },
        // {
        //   text: "Sms",
        //   value: "SMS",
        // },
        // {
        //   text: "Whatsapp",
        //   value: "WHATSAPP",
        // },
      ],
      notificationOption: "",
      templateOption: "",
      showPreviewHere: "",
      timestampDate: "",
      timestampTime: "",
    };
  },

  computed: {
    ...mapGetters({
      getPromoTemplateTypeList: "bulkNotification/GetPromoTemplateTypeList",
      getPreviewTemplate: "bulkNotification/GetPreviewTemplate",
      getDataCriteriaById: "bulkNotification/GetDataCriteriaById",
      getDataTemplateById: "bulkNotification/GetDataTemplateById",
      getPromoType: "partner/GetWalletData",
    }),
    typeOfPromo() {
      let walletPromoType = this.getPromoType
        .filter((type) => {
          if (!type.isCurrency) {
            return type;
          }
        })
        .map((promo) => {
          return {
            text: promo.name.charAt(0).toUpperCase() + promo.name.slice(1),
            value: promo.code,
            resourceKey: promo.resourceID
          };
        });
      return walletPromoType;
    },
    templateOptionList() {
      const selectTemplate = this.getPromoTemplateTypeList.map((template) => ({
        text: template.concern,
        value: template?._id || "",
      }));
      return selectTemplate;
    },

    selectedEntity() {
      const choosenEntity =
        this.getDataCriteriaById?.collectionName?.toLowerCase();
      return (
        choosenEntity?.charAt(0)?.toUpperCase() + choosenEntity?.slice(1) || ""
      );
    },

    selectedCriteriaOptions() {
      const selectedOptions = this.getDataCriteriaById?.filterBy?.map(
        (selectedOption) => {
          let result = selectedOption.field.replace(/([A-Z])/g, " $1");
          let textValue = result.charAt(0).toUpperCase() + result.slice(1);
          return textValue;
        }
      );
      return selectedOptions;
    },

    selectedOperator() {
      const selectedOptions = this.getDataCriteriaById?.filterBy?.map(
        (selectedOption) => {
          let result = selectedOption.filter.replace(/([A-Z])/g, " $1");
          let operatorText = result.charAt(0).toUpperCase() + result.slice(1);
          return operatorText;
        }
      );
      return selectedOptions;
    },

    inputData() {
      const inputEntered = this.getDataCriteriaById?.filterBy?.map(
        (criteriaData) => {
          if (criteriaData.data.value) {
            let enteredData = {
              value: criteriaData.data.value,
            };
            return enteredData;
          } else {
            let enteredData = {
              value: {
                startDate: criteriaData.data.gte,
                endDate: criteriaData.data.lte,
              },
            };
            return enteredData;
          }
        }
      );
      return inputEntered;
    },

    scheudleDateTime() {
      let scheduleDate =
        this.getDataTemplateById?.data?.scheduleDate?.split("T");
      if (scheduleDate) {
        return scheduleDate[0];
      }
    },
    scheudleTimeDate() {
      let scheduleTime =
        this.getDataTemplateById?.data?.scheduleDate?.split("T");
      let timeSchedule = scheduleTime[1]?.split(".");
      if (timeSchedule) {
        return timeSchedule[0];
      }
    },
  },

  methods: {
    downloadDetails() {
      if (this.getDataCriteriaById.status === "PENDING") {
        this.$swal({
          title: "Info",
          text: "Fetching Customer List. Please Wait...",
          type: "info",
        });
      } else if (
        this.getDataCriteriaById.count &&
        this.getDataCriteriaById.count !== 0
      ) {
        window.location = this.getDataCriteriaById.url;
      } else {
        this.$swal({
          title: "Error",
          text: "Data Not Available.",
          type: "error",
        });
      }
    },

    async templateTypeList() {
      this.templateOption = "";
      this.resourceId = this.promoType?.resourceKey || ""
      let payload = {
        service: this.notificationOption?.value || "",
        concern: this.promoType?.value || "",
      };
      if (payload.service && payload.concern) {
        await this.$store.dispatch(
          "bulkNotification/fetchPromoTemplateTypeList",
          payload
        );
      }
    },

    async previewSelectedTemplate() {
      let payload = {
        templateId: this.templateOption.value,
      };
      await this.$store.dispatch(
        "bulkNotification/fetchTemplateToPreview",
        payload
      );
      this.showPreviewHere = this.showPreview()
        .map((pre) => pre.body)
        .join("")
        .toString();
    },

    showPreview() {
      const previewTemplate = this.getPreviewTemplate.map((preview) => ({
        body: preview?.body || "",
      }));
      return previewTemplate;
    },

    async createBulkNotification() {
      if (this.getDataCriteriaById.count !== 0) {
        if (this.notificationOption.value && this.templateOption.value) {
          let payload = {
            criteria: {
              filterBy: this.getDataCriteriaById.filterBy,
              retriveParams: this.getDataCriteriaById.retriveParams,
              status: this.getDataCriteriaById.status,
              collectionName: this.getDataCriteriaById.collectionName,
              serviceUrl: this.getDataCriteriaById.serviceUrl,
              tenant: this.getDataCriteriaById.tenant,
              count: this.getDataCriteriaById.count,
              url: this.getDataCriteriaById.url,
              _id: this.getDataCriteriaById._id,
            },
            notificationType: this.notificationOption.value,
            template: {
              _id: this.getPreviewTemplate[0]._id,
              name: this.getPreviewTemplate[0].service,
              concern: this.getPreviewTemplate[0].concern,
              body: this.getPreviewTemplate[0].body,
              promotionType: this.promoType?.value,
              amount: this.promoAmount,
              type: "promo",
              key: this.resourceId,
              description: this.description,
            },
            description: this.description,
            scheduleDate: this.timestampDate,
            category: "PROMO",
          };
          await this.$store
            .dispatch("bulkNotification/createBulkNotification", payload)
            .then((result) => {
              this.$swal({
                title: "Successful",
                text: "Bulk Promotion Created Successfully!",
                type: "success",
              });
              this.$router.push("/bulkPromotion");
            })
            .catch((err) => {
              this.$swal({
                title: "Sorry",
                text: "Unable to Create Bulk Promotion!",
                type: "error",
              });
            });
        } else {
          this.$swal({
            title: "Error",
            text: "Select All Fields",
            type: "error",
          });
        }
      } else {
        this.$swal({
          title: "Error",
          text: "No Impacted Customer Available",
          type: "error",
        });
      }
    },
  },

  async mounted() {
    this.loading = true;
    let payload1 = { id: this.$route.params.id };
    await this.$store.dispatch(
      "bulkNotification/fetchDetailsCriteriaById",
      payload1
    );
    await this.$store.dispatch(
      "bulkNotification/fetchDetailsTemplateById",
      payload1
    );
    let payload = { label: this.getDataCriteriaById.collectionName };
    await this.$store.dispatch("bulkNotification/fetchEntities", payload);
    if (this.getDataCriteriaById.status === "PENDING") {
      this.$swal({
        title: "Info",
        text: "Fetching Customer List. Please Wait...",
        type: "info",
      });
    }
    await this.$store.dispatch("partner/fetchWalletList");

    this.promoType = this.getDataTemplateById?.data?.template?.promotionType;
    this.notificationOption = this.typeOfNotificationOption.filter((option) => {
      if (option.value == this.getDataTemplateById?.data?.template?.name) {
        return option;
      }
    });
    this.templateTypeList();
    this.templateOption = this.templateOptionList.filter((option) => {
      if (option.text == this.getDataTemplateById?.data?.template?.concern) {
        return option;
      }
    });
    this.promoAmount = this.getDataTemplateById?.data?.template?.amount;
    this.showPreviewHere = this.getDataTemplateById?.data?.template?.body;
    this.description = this.getDataTemplateById?.data?.description;
    this.timestampDate = this.scheudleDateTime;
    this.loading = false;
  },
};
</script>
<style scoped>
.previewTemplate {
  margin: 0px 15px;
  height: 150px;
  padding: 12px;
  border: 1px solid rgb(228, 214, 214);
  border-radius: 4px;
  min-width: 98%;
  overflow: auto;
}

.previewTemplate[contentEditable="false"]:empty:before {
  content: attr(placeholder);
}

.form-control {
  height: calc(2.2125rem + 8px);
}
.impactValueStyle {
  color: #33a02c;
}
.form-control:disabled, .form-control[readonly] {
    background-color: #f8f8f8;
    opacity: 1;
}
</style>
